import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/trusty-frontend/trusty-frontend/app/initApp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/trusty-frontend/trusty-frontend/app/providers.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/trusty-frontend/trusty-frontend/assets/globals.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/trusty-frontend/trusty-frontend/assets/img/NRICHED_Logo_yellow.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/trusty-frontend/trusty-frontend/components/authorization/CheckAuthorization.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/trusty-frontend/trusty-frontend/components/backoffice/ActionPointChecker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/trusty-frontend/trusty-frontend/components/layout/CompanyInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/trusty-frontend/trusty-frontend/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogComponent"] */ "/home/runner/work/trusty-frontend/trusty-frontend/components/ui/DialogComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/trusty-frontend/trusty-frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/trusty-frontend/trusty-frontend/node_modules/next/dist/client/image-component.js");
